<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} {{ aLang.rf_title }}</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} {{ aLang.rf_title }}</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} {{ aLang.rf_title }}</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="3">
              <el-form-item
                :label="aLang.rf_sender_reflects"
                prop="nguoi_gui_id"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_nguoi_gui"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.rf_phone_number" prop="dien_thoai">
                <el-input
                  type="text"
                  v-model="mData.dataForm.dien_thoai"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.user_email" prop="email">
                <el-input
                  type="text"
                  v-model="mData.dataForm.email"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
             <b-col md="3">
              <el-form-item
                :label="aLang.rf_status"
                prop="trang_thai"
                v-if="
                  (aRole('Admin') &&
                    mData.dataForm.trang_thai == 'forwarded_to_tcqltt' &&
                    mData.viewMode == 'detail') ||
                  !aRole('Admin')
                "
              >
                <el-select
                  v-model="mData.dataForm.trang_thai"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThai"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="aLang.rf_status"
                prop="trang_thai"
                v-if="
                  aRole('Admin') &&
                  mData.dataForm.trang_thai != 'forwarded_to_tcqltt' &&
                  mData.viewMode == 'detail'
                "
              >
                <el-select
                  v-model="mData.dataForm.trang_thai"
                  :placeholder="aLang.c_select"
                  @change="fn_changeTrangThai"
                  clearable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listTrangThai"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <el-form-item
                :label="aLang.rf_reflection_group"
                prop="nhom_phan_hoi"
              >
                <el-select
                  v-model="mData.dataForm.nhom_phan_hoi"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNhomPhanHoi"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.rf_reflect_to" prop="phan_hoi_den">
                <el-input
                  type="text"
                  v-model="mData.dataForm.phan_hoi_den"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col
              md="3"
              v-if="
                mData.dataForm.doi_tuong_phan_hoi &&
                (mData.dataForm.doi_tuong_phan_hoi.doi_tuong == 'DDAT' ||
                  mData.dataForm.doi_tuong_phan_hoi.doi_tuong == 'DNLH') &&
                mData.viewMode == 'detail'
              "
            >
              <el-form-item
                :label="aLang.rf_subjects_receiving_feedback"
                prop="doi_tuong_phan_hoi.doi_tuong"
              >
                <el-select
                  v-model="mData.dataForm.doi_tuong_phan_hoi.doi_tuong"
                  disabled
                >
                  <el-option
                    v-for="item in mData.dataDefault.listDoiTuong"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col
              md="3"
              v-if="
                mData.dataForm.doi_tuong_phan_hoi &&
                (mData.dataForm.doi_tuong_phan_hoi.doi_tuong == 'DDAT' ||
                  mData.dataForm.doi_tuong_phan_hoi.doi_tuong == 'DNLH') &&
                mData.viewMode == 'detail'
              "
            >
              <el-form-item
                :label="aLang.rf_name_of_object_receiving_feedback"
                prop="doi_tuong_phan_hoi.ten_doi_tuong"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong"
                  disabled
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item
                :label="aLang.rf_reflection_time"
                prop="thoi_diem_phan_hoi"
              >
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.thoi_diem_phan_hoi"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  >clearable</el-date-picker
                >
              </el-form-item>
            </b-col>
            <!-- <b-col md="4" v-if="!aRole('TCQLTT')"> -->
            <b-col md="3" v-if="mData.dataForm.doi_tuong_phan_hoi && mData.dataForm.doi_tuong_phan_hoi.doi_tuong">
              <el-form-item
                :label="aLang.rg_object_reflection"
              >
                <div class="el-input is-disabled">
                  <div class="el-input__inner" style="display: flex; align-items: center; background-color: #f5f7fa; border-color: #e4e7ed; height: 32px;">
                    <router-link
                      v-if="mData.dataForm.doi_tuong_phan_hoi.doi_tuong === 'HDV' && mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id"
                      :to="{ name: 'Admin-HuongDanVien-detail', params: { id: mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id } }"
                    >
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || 'Chi tiết Hướng dẫn viên' }}
                    </router-link>
                    <router-link
                      v-else-if="mData.dataForm.doi_tuong_phan_hoi.doi_tuong === 'DNLH' && mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id"
                      :to="{ name: 'Admin-CongTyLuHanh-detail', params: { id: mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id } }"
                    >
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || 'Chi tiết Doanh nghiệp lữ hành' }}
                    </router-link>
                    <router-link
                      v-else-if="mData.dataForm.doi_tuong_phan_hoi.doi_tuong === 'DDAT' && mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id"
                      :to="{ name: 'Admin-DiemDenAnToan-detail', params: { id: mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id } }"
                    >
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || 'Chi tiết Điểm đến' }}
                    </router-link>
                    <router-link
                      v-else-if="mData.dataForm.doi_tuong_phan_hoi.doi_tuong === 'TOUR' && mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id"
                      :to="{ name: 'Admin-Tour-detail', params: { id: mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id } }"
                    >
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || 'Chi tiết Tour' }}
                    </router-link>
                    <router-link
                      v-else-if="mData.dataForm.doi_tuong_phan_hoi.doi_tuong === 'CSLT' && mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id"
                      :to="{ name: 'Admin-CoSoLuuTru-detail', params: { id: mData.dataForm.doi_tuong_phan_hoi.doi_tuong_id } }"
                    >
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || 'Chi tiết Cơ sở lưu trú' }}
                    </router-link>
                    <span v-else>
                      {{ mData.dataForm.doi_tuong_phan_hoi.ten_doi_tuong || mData.dataForm.doi_tuong_phan_hoi.doi_tuong }}
                    </span>
                  </div>
                </div>
              </el-form-item>
            </b-col>
          </b-row>
          <!-- <b-row v-if="mData.dataForm.trang_thai=='forwarded_to_tcqltt'">
            <b-col md="4">
              <el-form-item label="Trạng thái xử lý của TCQLTT" prop="tcqltt.trang_thai" v-if="mData.dataForm.trang_thai=='forwarded_to_tcqltt'">
                <el-select
                  v-model="mData.dataForm.tcqltt.trang_thai"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThaiTcqltt"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="8">
              <el-form-item label="Lý do chuyển trạng thái" prop="phan_hoi_den">
                <el-input
                  type="text"
                  v-model="mData.dataForm.phan_hoi_den"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>-->

          <b-row class="mt-2">
            <b-col md="6">
              <b-row>
                <b-col md="12">
                  <el-form-item :label="aLang.rf_content" prop="noi_dung">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="mData.dataForm.noi_dung"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col
                  md="12"
                  v-if="mData.fileUploadOption.FileDinhKem.fileList.length > 0"
                >
                  <el-form-item class="mb-0" :label="aLang.rf_attached_files">
                    <!-- <el-upload
                      action
                      :auto-upload="false"
                      list-type="picture-card"
                      :limit="mData.fileUploadOption.FileDinhKem.limit"
                      :accept="mData.fileUploadOption.FileDinhKem.accept"
                      :on-change="fn_uploadChangeFileDinhKem"
                      :on-preview="fn_uploadPreviewFileDinhKem"
                      :on-remove="fn_uploadRemoveFileDinhKem"
                      :on-exceed="fn_uploadExceedFileDinhKem"
                      multiple
                      :file-list="mData.fileUploadOption.FileDinhKem.fileList"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog
                      :close-on-click-modal="true"
                      :visible.sync="mData.fileUploadOption.FileDinhKem.dialogVisible"
                      width="60%"
                      top="51px"
                      title="Chi tiết"
                    >
                      <img
                        width="100%"
                        :src="mData.fileUploadOption.FileDinhKem.dialogImageUrl"
                        alt
                      />
                    </el-dialog>-->
                    <b-row>
                      <b-col
                        md="3"
                        sm="4"
                        class="text-center mt-2"
                        v-for="item in mData.fileUploadOption.FileDinhKem
                          .fileList"
                        :key="item.name"
                      >
                        <el-image
                          style="width: 90px; height: 90px"
                          :src="item.url"
                          :preview-src-list="mData.dataDefault.listFileDinhKem"
                          v-if="!fn_checkVideo(item)"
                        >
                          <div slot="error" class="el-image__error">
                            <!-- <i class="el-icon-picture-outline"></i> -->
                            <span class="small" style="line-height: 1rem">{{
                              item.name
                            }}</span>
                          </div>
                        </el-image>
                        <div
                          style="position: relative; cursor: pointer"
                          v-if="fn_checkVideo(item)"
                          @click="fn_playVideo(item)"
                        >
                          <video width="90px" height="90px">
                            <source
                              :src="item.url"
                              :type="fn_changeType(item.extension)"
                            />
                          </video>
                          <div
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              width: 24px;
                              height: 24px;
                              border-radius: 36px;
                              background-color: rgba(80, 67, 67, 0.79);
                              display: flex;
                              align-items: center;
                              border: 1px solid #ffffff;
                            "
                          >
                            <i
                              class="fa fa-play"
                              style="
                                font-size: 14px;
                                color: #ffffff;
                                font-weight: 100;
                                margin-left: 7px;
                              "
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                        <div>
                          <el-button
                            @click="fn_download(item)"
                            type="info"
                            size="small"
                            plain
                            >Tải về</el-button
                          >
                        </div>
                      </b-col>
                    </b-row>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <!-- <b-col md="6">
                  <el-form-item label=" " prop>
                    <el-checkbox
                      v-model="mData.dataPropMapDiaDiem.showMap"
                      :disabled="mData.viewMode == 'detail'"
                    >Địa điểm trên bản đồ</el-checkbox>
                  </el-form-item>
                </b-col>-->
                <!-- <b-col md="12">
                  Địa điểm trên bản đồ
                  <map-component
                    :prop-data-map="mData.dataPropMapDiaDiem"
                    v-if="mData.dataPropMapDiaDiem.showMap"
                    :prop-disabled="mData.viewMode == 'detail'"
                  ></map-component>
                </b-col>-->

                <b-col md="12">
                  <el-form-item :label="aLang.rf_location_on_the_map" prop>
                    <mapbox-component-h300
                      :viewMode="mData.viewMode"
                      @update="fn_getDataFromMapboxComponent"
                      :config="mData.config"
                      :cordinatesValue="mData.mapDataObject.value"
                      v-if="mData.dataDefault.showMap"
                      id="mapBox"
                    ></mapbox-component-h300>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            class="mt-3"
            v-if="aRole('Admin,Officer,VNATAdmin,TCQLTT,SVHTT')"
          >
            <b-col md="12" class="mb-2">{{
              aLang.rf_transfer_history_reflects
            }}</b-col>
            <div class="col-md-12">
              <el-table
                :data="mData.dataDefault.listLichSu"
                border
                max-height="440"
                style="width: 100%; display: grid"
                :row-class-name="fn_tableRowClassName"
              >
                <el-table-column
                  prop="ten_tu"
                  :label="aLang.rf_from"
                  width="100"
                  title="ten_tu"
                ></el-table-column>
                <el-table-column
                  prop="ten_den"
                  :label="aLang.rf_to"
                  width="100"
                  title="ten_den"
                ></el-table-column>

                <el-table-column
                  prop="ly_do"
                  :label="aLang.rf_cause"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start">
                      <p>{{ scope.row.ly_do | replaceText }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.ly_do | replaceText }}
                      </div>
                    </el-popover>
                    <!-- <el-tooltip class="item" effect="light" :content="scope.row.ly_do" placement="top-start">
                      {{ scope.row.ly_do }}
                    </el-tooltip>-->
                  </template>
                </el-table-column>
                <el-table-column
                  prop="thoi_diem"
                  :label="aLang.rf_time"
                  width="130"
                  align="center"
                  :formatter="fn_formatterDatetime"
                ></el-table-column>
                <el-table-column
                  prop="file_dinh_kem"
                  :label="aLang.rf_attached_files"
                  min-width="250"
                  align="center"
                >
                  <!-- <template slot-scope="scope">
                    <tr
                      v-for="item in scope.row.file_dinh_kem"
                      :key="item"
                      :label="item"
                      :value="item"
                      style="background-color:none;"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLink(item)"
                        :underline="false"
                      >{{fn_formatterLinkName(item)}}</el-link>
                    </tr>
                  </template>-->
                  <template slot-scope="scope">
                    <p
                      v-for="item in scope.row.file_dinh_kem"
                      :key="item"
                      style="display: inline; width: 100%"
                      class="text-wrap"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLink(item)"
                        :underline="false"
                        >{{ fn_formatterLinkName(item) }},</el-link
                      >
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-row>

          <b-row class="mt-3" v-if="aRole('Admin,Officer,VNATAdmin,SVHTT')">
            <b-col md="12" class="mb-2"
              >Lịch sử chuyển trạng thái {{ phanHoiText }}</b-col
            >
            <div class="col-md-12">
              <el-table
                :data="mData.dataDefault.listLichSuChuyenPhanAnh"
                border
                max-height="440"
                style="width: 100%; display: grid"
                :row-class-name="fn_tableRowClassName"
              >
                <el-table-column
                  prop="nguoi_thay_doi"
                  label="Người thay đổi"
                  width="220"
                ></el-table-column>

                <el-table-column
                  prop="noi_dung_hoi_dap"
                  label="Nội dung hồi đáp"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start">
                      <p>{{ scope.row.noi_dung_hoi_dap | replaceText }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.noi_dung_hoi_dap | replaceText }}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="file_hoi_dap_ids"
                  label="File hồi đáp người phản ánh"
                  min-width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p
                      v-for="item in scope.row.file_hoi_dap_ids"
                      :key="item"
                      style="display: inline; width: 100%"
                      class="text-wrap"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLinkHoiDap(item)"
                        :underline="false"
                        >{{ fn_formatterLinkHoiDapName(item) }},</el-link
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="noi_dung_xu_ly"
                  label="Nội dung xử lý"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start">
                      <p>{{ scope.row.noi_dung_xu_ly | replaceText }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.noi_dung_xu_ly | replaceText }}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="file_xu_ly_ids"
                  label="File đính kèm"
                  min-width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p
                      v-for="item in scope.row.file_xu_ly_ids"
                      :key="item"
                      style="display: inline; width: 100%"
                      class="text-wrap"
                    >
                      <el-link
                        class="cell-child"
                        target="_blank"
                        :href="fn_formatterLinkXuLy(item)"
                        :underline="false"
                        >{{ fn_formatterLinkXuLyName(item) }},</el-link
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="trang_thai_truoc"
                  label="Trạng thái trước"
                  min-width="75"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.trang_thai_truoc == "new"
                        ? "Mới"
                        : scope.row.trang_thai_truoc == "processing"
                        ? "Đang xử lý"
                        : scope.row.trang_thai_truoc == "processed"
                        ? "Đã xử lý"
                        : scope.row.trang_thai_truoc == "forwarded_to_tcqltt"
                        ? "Chuyển TCQLTT"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="trang_thai_sau"
                  label="Trạng thái sau"
                  min-width="70"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.trang_thai_sau == "new"
                        ? "Mới"
                        : scope.row.trang_thai_sau == "processing"
                        ? "Đang xử lý"
                        : scope.row.trang_thai_sau == "processed"
                        ? "Đã xử lý"
                        : scope.row.trang_thai_sau == "forwarded_to_tcqltt"
                        ? "Chuyển TCQLTT"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="thoi_diem"
                  label="Thời điểm"
                  width="130"
                  align="center"
                  :formatter="fn_formatterDatetime"
                ></el-table-column>
              </el-table>
            </div>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >{{ aLang.c_create }}</el-button
            >

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >{{ aLang.c_update }}</el-button
            >

            <el-button
              type="info"
              plain
              v-if="mData.viewMode == 'detail' && aRole('TCQLTT')"
              :disabled="!mData.dataDefault.allowChange"
              @click="
                mData.dataDefault.dialogChuyenTrangThai =
                  !mData.dataDefault.dialogChuyenTrangThai
              "
              >Chuyển trạng thái</el-button
            >

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      :visible.sync="mData.dataDefault.dialogChuyenTrangThai"
      :title="aLang.c_changeStatus + ' xử lý ' + phanHoiText"
    >
      <chuyen-trang-thai-xu-ly-phan-hoi
        :componentProps="mData.dataDefault.dataForDialog"
      ></chuyen-trang-thai-xu-ly-phan-hoi>
    </el-dialog>

    <div
      style="
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(80, 67, 67, 0.79);
        top: 0;
        left: 0;
        z-index: 99999;
      "
      v-if="mData.dataDefault.dialogVideo.show"
    >
      <div
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 80%;
          max-height: 80%;
        "
      >
        <video autoplay controls style="max-height: 100vh">
          <source
            :src="mData.dataDefault.dialogVideo.src"
            :type="mData.dataDefault.dialogVideo.type"
          />
        </video>
      </div>
      <div
        style="position: absolute; right: 20px; top: 10px; cursor: pointer"
        @click="fn_closeDialogVideo()"
      >
        <i
          class="fa fa-times"
          style="font-size: 36px; color: #ffffff"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import PhanHoiModel from "./PhanHoiModel";
import PhanHoiApi from "../../../moduleApi/PhanHoiApi";
import AccountApi from "../../../moduleApi/AccountApi";
import NhomPhanHoiApi from "../../../moduleApi/NhomPhanHoiApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import TourApi from "../../../moduleApi/TourApi";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";
import FileApi from "../../../moduleApi/FileApi";
import MapComponent from "../../../component/MapComponent";
import MapboxComponentH300 from "@/component/MapboxComponentH300";
import DiemDenAntoanApi from "../../../moduleApi/DiemDenAnToanApi";
import ChuyenTrangThaiXuLyPhanHoi from "../../../component/ChuyenTrangThaiXuLyPhanHoi";
import mushroom from "mushroomjs";
export default {
  components: {
    MapComponent,
    MapboxComponentH300,
    ChuyenTrangThaiXuLyPhanHoi,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "PhanHoi",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          // listCongTyLuHanh: [],
          listNguoiGuiPhanHoi: [],
          // listTour: [],
          listNhomPhanHoi: [],
          listFileDinhKem: [],
          listDoiTuongPhanHoi: MethodService.copyObject(
            PhanHoiModel.doiTuongPhanHoi
          ),
          trangThai: PhanHoiModel.trangThai,
          trangThaiTcqltt: PhanHoiModel.trangThaiTcqltt,
          listLichSu: [],
          listLichSuChuyenPhanAnh: [],
          listFileTcqltt: [],
          listNguoiXuLy: [],
          // listFileId: "",
          listFileId: [],
          listFileHoiDap: [],
          listFileXuLy: [],
          listFileHoiDapId: [],
          listFileXuLyId: [],
          listDoiTuong: MethodService.copyObject(PhanHoiModel.doiTuong),
          showMap: false,
          dialogChuyenTrangThai: false,
          dataForDialog: {},
          allowChange: false,
          listTrangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          dialogVideo: {
            show: false,
            src: "",
            type: "",
          },
        },
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        validForm: PhanHoiModel.validForm,
        fileUploadOption: MethodService.copyObject(
          PhanHoiModel.dataFormOther.fileUploadOption
        ),
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        // coordinatess: [105.75,21],
        dialog: {},
      },
      phanHoiText: "phản ánh",
      phanHoiTextUC: "Phản ánh",
    };
  },
  filters: {
    replaceText: function (value) {
      if (!value) return "";
      // if (!MethodService.checkRole('TCQLTT')) {
      //   return value;
      // }
      return value.replaceAll(/phản hồi/gi, "phản ánh");
    },
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await PhanHoiApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await PhanHoiApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.fileUploadOption = MethodService.copyObject(
        PhanHoiModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await PhanHoiApi.findById(id);
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(PhanHoiModel.dataForm),
        res.result
      );
      let resKhachDuLichApi = await KhachDuLichApi.findById(
        resData.nguoi_gui_id
      );
      if (resKhachDuLichApi.result) {
        if (
          resKhachDuLichApi.result.ho_ten &&
          resKhachDuLichApi.result.ho_ten.ho_ten &&
          resKhachDuLichApi.result.ho_ten.ho_ten.trim() != ""
        ) {
          resData.ten_nguoi_gui = resKhachDuLichApi.result.ho_ten.ho_ten;
        } else {
          resData.ten_nguoi_gui = "Chưa có thông tin";
        }
        if (resKhachDuLichApi.result.email) {
          resData.email = resKhachDuLichApi.result.email;
        } else {
          resData.email = "Chưa có thông tin";
        }
        resData.dien_thoai = resKhachDuLichApi.result.dien_thoai;
      } else {
        let resHuongDanVienApi = await HuongDanVienApi.findById(
          resData.nguoi_gui_id
        );
        if (resHuongDanVienApi.result) {
          resData.ten_nguoi_gui = resHuongDanVienApi.result.ho_ten.ho_ten;
          resData.dien_thoai = resHuongDanVienApi.result.dien_thoai;
        }
      }

      if (resData.file_dinh_kem && resData.file_dinh_kem.length > 0) {
        let imageExtension = [
          ".jpg",
          ".jpeg",
          ".png",
          ".gif",
          ".bmp",
          ".tiff",
          ".webp",
          ".svg",
        ];
        let listFile = await FileApi.list({
          limit: resData.file_dinh_kem.length,
          filters: "id:in:" + resData.file_dinh_kem.join(","),
        });

        //let dataFilter = [];
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.forEach((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });

          let imageUrls = listFile.result
            .filter(
              (x) =>
                typeof x.extension == "string" &&
                imageExtension.includes(x.extension.toLowerCase())
            )
            .map((a) => a.url);
          this.mData.dataDefault.listFileDinhKem = imageUrls;
        }
        // debugger;
        this.mData.fileUploadOption.FileDinhKem.fileList = data;
      }

      if (resData.cong_ty_lu_hanh_id) {
        let resCongTyLuHanhApi = await CongTyLuHanhApi.findById(
          resData.cong_ty_lu_hanh_id
        );
        resData.phan_hoi_den = resCongTyLuHanhApi.result.ten.vi;
      } else {
        resData.phan_hoi_den = "Cơ quan quản lý";
      }
      // debugger;
      if (
        res.result &&
        res.result.loc &&
        res.result.loc.coordinates &&
        res.result.loc.coordinates.length >= 2
      ) {
        this.mData.dataPropMapDiaDiem.lat = res.result.loc.coordinates[1];
        this.mData.dataPropMapDiaDiem.lng = res.result.loc.coordinates[0];
        this.mData.dataPropMapDiaDiem.showMap = true;
        // debugger;
        if (
          res.result.loc.coordinates[1] == null ||
          res.result.loc.coordinates[0] == null
        ) {
          this.mData.dataDefault.showMap = false;
        } else {
          let coordinate = [
            res.result.loc.coordinates[0],
            res.result.loc.coordinates[1],
          ];

          this.mData.mapDataObject.value = coordinate;
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        }
      }
      // debugger

      if (
        res.result &&
        res.result.tcqltt &&
        res.result.tcqltt.lich_su &&
        res.result.tcqltt.lich_su.length > 0
      ) {
        let resLichSu = res.result.tcqltt.lich_su;

        let tuIds = MethodService.findListItemDifferent(resLichSu, "tu");
        let denIds = MethodService.findListItemDifferent(resLichSu, "den");
        let resTu = await AccountApi.list({
          filters: "id:in:" + tuIds.join(","),
        });
        let resDen = await AccountApi.list({
          filters: "id:in:" + denIds.join(","),
        });

        resLichSu.forEach((item) => {
          const nguoiTu = resTu.result.find(
            (element) => element.id === item.tu
          );

          item.ten_tu = nguoiTu ? nguoiTu.account : "";

          const nguoiDen = resDen.result.find(
            (element) => element.id === item.den
          );
          item.ten_den = nguoiDen ? nguoiDen.account : "";
          if (item.file_dinh_kem && item.file_dinh_kem.length > 0) {
            this.mData.dataDefault.listFileId.push(...item.file_dinh_kem);
          }
        });
        let listFileIds = this.mData.dataDefault.listFileId;
        let listFileTc = await FileApi.list({
          filters: "id:in:" + listFileIds.join(","),
        });
        let data = [];
        if (listFileTc && listFileTc.result) {
          data = listFileTc.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.dataDefault.listFileTcqltt = data;

        // $.each(resLichSu, (index, item) => {
        //   if (item.file_dinh_kem && item.file_dinh_kem.length > 0) {
        //     $.each(item.file_dinh_kem, (idx, e) => {
        //         let resfind = this.mData.dataDefault.listFileTcqltt.find(
        //           element => {
        //             return element.id == e;
        //           }
        //         );
        //         if (resfind) {
        //           e.filename=resfind.name;
        //           e.fileurl=resfind.url;
        //         }

        //     });
        //   }
        // });

        // debugger;
        this.mData.dataDefault.listLichSu = resLichSu;
        // debugger;
      }

      //Lịch sử chuyển phản 'ánh'
      if (res.result && res.result.lich_su && res.result.lich_su.length > 0) {
        let resLichSuChuyenPhanAnh = res.result.lich_su;

        let nguoiThayDoiIds = MethodService.findListItemDifferent(
          resLichSuChuyenPhanAnh,
          "nguoi_thay_doi_id"
        );
        let resNguoiThayDoi = await AccountApi.list({
          filters: "id:in:" + nguoiThayDoiIds.join(","),
        });
        resLichSuChuyenPhanAnh.forEach((item) => {
          const nguoiThayDoi = resNguoiThayDoi.result.find((element) => {
            return element.id === item.nguoi_thay_doi_id;
          });

          item.nguoi_thay_doi = nguoiThayDoi ? nguoiThayDoi.account : "";

          if (item.file_hoi_dap_ids && item.file_hoi_dap_ids.length > 0) {
            this.mData.dataDefault.listFileHoiDapId.push(
              ...item.file_hoi_dap_ids
            );
          }
          if (item.file_xu_ly_ids && item.file_xu_ly_ids.length > 0) {
            this.mData.dataDefault.listFileXuLyId.push(...item.file_xu_ly_ids);
          }
        });
        let listFileHoiDapIds = this.mData.dataDefault.listFileHoiDapId;
        let listFileXuLyIds = this.mData.dataDefault.listFileXuLyId;
        let listFileHoiDapTc = await FileApi.list({
          filters: "id:in:" + listFileHoiDapIds.join(","),
        });
        let listFileXuLyTc = await FileApi.list({
          filters: "id:in:" + listFileXuLyIds.join(","),
        });
        let dataHoiDap = [];
        let dataXuLy = [];
        if (listFileHoiDapTc && listFileHoiDapTc.result) {
          dataHoiDap = listFileHoiDapTc.result;
          dataHoiDap.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        if (listFileXuLyTc && listFileXuLyTc.result) {
          dataXuLy = listFileXuLyTc.result;
          dataXuLy.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.dataDefault.listFileHoiDap = dataHoiDap;
        this.mData.dataDefault.listFileXuLy = dataXuLy;
        this.mData.dataDefault.listLichSuChuyenPhanAnh = resLichSuChuyenPhanAnh;
      }
      //end check
      let resDDAT = null;
      let idDDAT = null;
      if (res.result) {
        if (res.result.diem_den_an_toan_id) {
          idDDAT = res.result.diem_den_an_toan_id;
        } else {
          if (res.result.doi_tuong_phan_hoi) {
            if (res.result.doi_tuong_phan_hoi.doi_tuong === "DDAT")
              idDDAT = res.result.doi_tuong_phan_hoi.doi_tuong_id || null;
          }
        }
      }

      if (!res.result.doi_tuong_phan_hoi) {
        res.result.doi_tuong_phan_hoi = {};
      }

      if (idDDAT) {
        res.result.doi_tuong_phan_hoi.doi_tuong = "DDAT";
        res.result.doi_tuong_phan_hoi.doi_tuong_id = idDDAT;
      }

      res.result.doi_tuong_phan_hoi.ten_doi_tuong = null;

      if (res.result.doi_tuong_phan_hoi && res.result.doi_tuong_phan_hoi.doi_tuong) {
        const type = res.result.doi_tuong_phan_hoi.doi_tuong;
        if (type === "HDV" || type === "DNLH" || type === "DDAT" || type === "TOUR" || type === "CSLT") {
          res.result.doi_tuong_phan_hoi.ten_doi_tuong = await this.fn_getTenDoiTuongPhanHoi(res.result.doi_tuong_phan_hoi);
        }
      }

      let user = MethodService.getCurrentUser();
      if (
        res.result &&
        res.result.tcqltt &&
        res.result.tcqltt.nguoi_xu_ly_id &&
        res.result.tcqltt.nguoi_xu_ly_id == user.id
      ) {
        this.mData.dataDefault.allowChange = true;
      }

      if (
        res.result &&
        res.result.trang_thai &&
        res.result.trang_thai != "forwarded_to_tcqltt" &&
        this.mData.viewMode == "detail" &&
        MethodService.checkRole("Admin")
      ) {
        this.mData.dataDefault.listTrangThai.pop();
      }
      // debugger;
      this.mData.dataDefault.dataForDialog = {
        id: id,
        mode: "updateTcqltt",
      };
      this.mData.dataForm = resData;
    },
    async fn_getTenDoiTuongPhanHoi(doiTuongPhanHoi) {
      if (!doiTuongPhanHoi || !doiTuongPhanHoi.doi_tuong || !doiTuongPhanHoi.doi_tuong_id) {
        return "";
      }
      const id = doiTuongPhanHoi.doi_tuong_id;
      if (doiTuongPhanHoi.doi_tuong === "HDV") {
        let thongTinHDV = "";
        try {
          const res = await HuongDanVienApi.findById(id);
          if(res && res.result) {
            if(res.result.the_hdv && res.result.the_hdv.so_the) thongTinHDV += res.result.the_hdv.so_the + " - ";
          }
          if (res && res.result && res.result.ho_ten) {
            thongTinHDV += res.result.ho_ten.ho_ten || "";
          }
          return thongTinHDV;
        } catch (e) {
          console.error(e);
        }
      } else if (doiTuongPhanHoi.doi_tuong === "DNLH") {
        try {
          const res = await CongTyLuHanhApi.findById(id);
          if (res && res.result) {
            let codeDNLH = null;
            let tenDNLH = null;
            if (res.result.ten) tenDNLH = res.result.ten.vi || null;
            const idNguoiQuanLy = res.result.nguoi_quan_ly_ids[0] || null;
            if (idNguoiQuanLy) {
              const resNguoiQuanLy = await mushroom.user.findByIdAsync({
                id: idNguoiQuanLy,
              });
              if (resNguoiQuanLy && resNguoiQuanLy.result) {
                codeDNLH = resNguoiQuanLy.result.account || null;
              }
            }
            return codeDNLH ? codeDNLH + " - " + tenDNLH : tenDNLH || "";
          }
        } catch (e) {
          console.error(e);
        }
      } else if (doiTuongPhanHoi.doi_tuong === "DDAT") {
        try {
          const res = await DiemDenAntoanApi.findById(id);
          if (res && res.result) {
            let codeDDAT = "";
            let tenDDAT = "";
            if (
              res.result.du_lieu_khai_bao &&
              res.result.du_lieu_khai_bao.user_account
            ) {
              codeDDAT = res.result.du_lieu_khai_bao.user_account;
            }
            if (
              res.result.thong_tin_chung &&
              res.result.thong_tin_chung.ten
            ) {
              tenDDAT = res.result.thong_tin_chung.ten;
            }
            return codeDDAT ? codeDDAT + " - " + tenDDAT : tenDDAT || "";
          }
        } catch (e) {
          console.error(e);
        }
      } else if (doiTuongPhanHoi.doi_tuong === "TOUR") {
        try {
          const res = await TourApi.findById(id);
          if (res && res.result) {
            return res.result.ten_tour || "";
          }
        } catch (e) {
          console.error(e);
        }
      } else if (doiTuongPhanHoi.doi_tuong === "CSLT") {
        try {
          const res = await CoSoLuuTruApi.findById(id);
          if (res && res.result && res.result.ten) {
            return res.result.ten.vi || "";
          }
        } catch (e) {
          console.error(e);
        }
      }
      return "";
    },
    async fn_initDataDefault() {
      // let reqCongTyLuHanhApi = CongTyLuHanhApi.list({ limit: 1000 });
      // let reqTourApi = TourApi.list({ limit: 1000 });
      let reqNhomPhanHoiApi = NhomPhanHoiApi.list({ limit: 1000 });

      // let resCongTyLuHanhApi = await reqCongTyLuHanhApi;
      // let resTourApi = await reqTourApi;
      let resNhomPhanHoiApi = await reqNhomPhanHoiApi;

      // this.mData.dataDefault.listCongTyLuHanh = resCongTyLuHanhApi.result;
      // this.mData.dataDefault.listTour = resTourApi.result;
      this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
      this.mData.dataDefault.listNhomPhanHoi.unshift({
        id: null,
        ten: {
          vi: "Chưa có thông tin",
        },
      });
    },

    fn_tableRowClassName({ row }) {
      if (row.trang_thai == "waiting") {
        return "success-row";
      }
      return "";
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterLink(id) {
      return ExtensionService.urlFile + id;
      // if (this.mData.dataDefault.listFileTcqltt) {
      //   let resfind = this.mData.dataDefault.listFileTcqltt.find(element => {
      //     return element.id == id;
      //   });
      //   if (resfind) {
      //     return resfind.url;
      //   }
      // }
      // return "";
    },
    fn_formatterLinkHoiDap(id) {
      return ExtensionService.urlFile + id;
    },
    fn_formatterLinkXuLy(id) {
      return ExtensionService.urlFile + id;
    },
    fn_formatterLinkName(id) {
      if (this.mData.dataDefault.listFileTcqltt) {
        let resfind = this.mData.dataDefault.listFileTcqltt.find((element) => {
          return element.id == id;
        });
        // debugger;
        if (resfind) {
          return decodeURI(resfind.name);
        }
      }
      return "File";
      // let resFind= await FileApi.findById(id);
      // debugger
      // if (resFind.result){
      //   return resFind.result.name;
      // } else {
      //   return 'File';
      // }
    },
    fn_formatterLinkHoiDapName(id) {
      if (this.mData.dataDefault.listFileHoiDap) {
        let resfind = this.mData.dataDefault.listFileHoiDap.find((element) => {
          return element.id == id;
        });
        if (resfind) {
          return decodeURI(resfind.name);
        }
      }
      return "File";
    },
    fn_formatterLinkXuLyName(id) {
      if (this.mData.dataDefault.listFileXuLy) {
        let resfind = this.mData.dataDefault.listFileXuLy.find((element) => {
          return element.id == id;
        });
        if (resfind) {
          return decodeURI(resfind.name);
        }
      }
      return "File";
    },
    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },
    fn_uploadRemoveFileDinhKem(file, fileList) {
      let data = [];
      fileList.forEach((el) => {
        data.push(el.id);
      });
      this.mData.dataForm.file_dinh_kem = data;
    },
    fn_uploadChangeFileDinhKem(file, fileList) {
      ExtensionService.upload(file, "phanHoi")
        .then((res) => {
          this.mData.dataForm.file_dinh_kem.push(res.result);
          const targetFile = fileList.find((el) => el.uid === file.uid);
          if (targetFile) {
            targetFile.id = res.result;
          }
          this.mData.fileUploadOption.FileDinhKem.fileList = fileList;
        })
        .catch(() => {
          const index = fileList.findIndex((el) => el.uid === file.uid);
          if (index !== -1) {
            fileList.splice(index, 1);
          }
        });
    },
    // fn_uploadExceedFileDinhKem(files, fileList) {
    //   window.toastr.info(
    //     `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKem.limit} file`
    //   );
    // },
    fn_uploadPreviewFileDinhKem(file) {
      this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },

    fn_download(file) {
      // this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      // this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;

      window.open(ExtensionService.urlFile + file.id);
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.loc.coordinates[0] = lng;
      this.mData.dataForm.loc.coordinates[1] = lat;
    },

    fn_getDataFromMapboxComponent(value) {
      // debugger
      this.mData.mapDataObject = value;
    },

    async fn_changeTrangThai() {
      let data = {
        id: this.mData.dataForm.id,
        trang_thai: this.mData.dataForm.trang_thai,
      };
      await PhanHoiApi.update(data);
      this.fn_initTable();
      this.$store.commit("fn_countPhanHoi");
    },

    fn_checkVideo(item) {
      let extensions = [".mp4", ".webm", ".ogg"];
      if (item.extension && extensions.includes(item.extension)) {
        return true;
      }
      return false;
    },

    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },

    fn_playVideo(item) {
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(
        item.extension
      );
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
